import { render, staticRenderFns } from "./DomainActivity.vue?vue&type=template&id=0bd86512&scoped=true&"
import script from "./DomainActivity.vue?vue&type=script&lang=js&"
export * from "./DomainActivity.vue?vue&type=script&lang=js&"
import style0 from "./DomainActivity.vue?vue&type=style&index=0&id=0bd86512&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd86512",
  null
  
)

export default component.exports